(function () {
  if (window.__gfSmartDealInit) return;
  window.__gfSmartDealInit = true;

  var ROOT = '[data-gf-smart-deal]';
  var shieldUntil = 0;
  var lastFocus = null;
  var scrollY = 0;
  var selectedGift = null;
  var giftAddInFlight = false;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isOpen() {
    var sheet = qs('.gf-sd-sheet.is-open');
    return !!sheet;
  }

  function insideSheet(target) {
    return !!(target && target.closest && target.closest('.gf-sd-sheet'));
  }

  function lockPage() {
    scrollY = window.scrollY;
    document.body.classList.add('gf-sd-open');
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }

  function unlockPage() {
    document.body.classList.remove('gf-sd-open');
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openSheet() {
    var trigger = qs('[data-gf-sd-open]');
    var sheet = qs('.gf-sd-sheet');
    var scrim = qs('[data-gf-sd-scrim]');
    if (!sheet || !scrim) return;
    lastFocus = document.activeElement;
    if (sheet.parentElement !== document.body) document.body.appendChild(sheet);
    if (scrim.parentElement !== document.body) document.body.appendChild(scrim);
    sheet.hidden = false;
    scrim.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    sheet.classList.add('is-open');
    scrim.classList.add('is-visible');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    lockPage();
    loadGifts(sheet);
    var closeBtn = qs('[data-gf-sd-close]', sheet);
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 40);
  }

  function closeSheet() {
    var trigger = qs('[data-gf-sd-open]');
    var sheet = qs('.gf-sd-sheet');
    var scrim = qs('[data-gf-sd-scrim]');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('is-visible');
      scrim.hidden = true;
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    unlockPage();
    shieldUntil = Date.now() + 450;
    setTimeout(function () {
      if (!sheet.classList.contains('is-open')) sheet.hidden = true;
    }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function blockUnderlying(e) {
    if (!isOpen() && Date.now() >= shieldUntil) return false;
    if (isOpen() && insideSheet(e.target)) return false;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (isOpen()) closeSheet();
    return true;
  }

  function numericId(value) {
    var raw = String(value || '');
    var parts = raw.split('/');
    var tail = parts[parts.length - 1];
    return String(parseInt(tail, 10) || '');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function giftImage(product) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) {
      var first = product.images[0];
      return typeof first === 'string' ? first : first.src || '';
    }
    return '';
  }

  function parseMoney(value) {
    var n = parseFloat(value);
    return isFinite(n) ? n : 0;
  }

  function giftWorth(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var compare = parseMoney(variant.compare_at_price) || parseMoney(product.compare_at_price);
    var price = parseMoney(variant.price) || parseMoney(product.price);
    return compare > price ? compare : price;
  }

  function formatWorth(amount) {
    if (!amount || amount <= 0) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Math.round(amount * 100));
    }
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      var isWhole = Math.abs(amount - Math.round(amount)) < 0.001;
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (err) {
      return '$' + (Math.abs(amount - Math.round(amount)) < 0.001 ? String(Math.round(amount)) : amount.toFixed(2));
    }
  }

  function firstAvailableVariantId(product) {
    var variants = product.variants || [];
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) return String(variants[i].id);
    }
    return variants[0] ? String(variants[0].id) : '';
  }

  function giftFromButton(btn) {
    if (!btn) return null;
    var price = parseMoney(btn.dataset.price);
    return {
      id: String(btn.dataset.giftId || ''),
      variantId: String(btn.dataset.variantId || ''),
      title: btn.dataset.title || 'Gift',
      price: price,
    };
  }

  function updateGiftChip(gift) {
    var chip = qs('[data-gf-sd-gift-chip]');
    var titleEl = qs('[data-gf-sd-gift-title]');
    var statusEl = qs('[data-gf-sd-gift-status]');
    if (!chip) return;
    if (!gift) {
      chip.classList.remove('is-selected');
      if (titleEl) titleEl.textContent = 'FREE Gift';
      if (statusEl) statusEl.textContent = '';
      return;
    }
    chip.classList.add('is-selected');
    if (titleEl) titleEl.textContent = 'FREE Gift';
    if (statusEl) {
      var money = formatWorth(gift.price);
      statusEl.textContent = money ? 'Selected • Save ' + money : 'Selected';
    }
  }

  function hideEmptyGiftOffer() {
    var chip = qs('[data-gf-sd-gift-chip]');
    var panel = qs('[data-gf-sd-panel="gift"]');
    var tab = qs('[data-gf-sd-tab="gift"]');
    if (chip) chip.remove();
    if (panel) panel.remove();
    if (tab) tab.remove();
    selectedGift = null;
    var root = qs(ROOT);
    var remaining = qsa('.gf-smart-deal__chip', root).length;
    if (root) root.setAttribute('data-offer-count', String(remaining));
    var countEl = qs('.gf-smart-deal__count', root);
    if (countEl) countEl.textContent = remaining + (remaining === 1 ? ' Offer' : ' Offers');
    var allTab = qs('[data-gf-sd-tab="all"]');
    if (allTab) allTab.textContent = 'All Offers (' + remaining + ')';
  }

  function applyGiftSelection(btn) {
    var track = btn && btn.parentNode;
    qsa('.gf-sd-gift', track).forEach(function (item) {
      var on = item === btn;
      item.classList.toggle('is-selected', on);
      item.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    selectedGift = giftFromButton(btn);
    updateGiftChip(selectedGift);
  }

  function renderGifts(track, products) {
    track.innerHTML = '';
    if (!products.length) {
      track.classList.add('is-empty');
      hideEmptyGiftOffer();
      return;
    }
    track.classList.remove('is-empty');
    products.forEach(function (product, index) {
      var autoSelect = products.length === 1 && index === 0;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gf-sd-gift' + (autoSelect ? ' is-selected' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', autoSelect ? 'true' : 'false');
      btn.dataset.giftId = String(product.id);
      btn.dataset.variantId = firstAvailableVariantId(product);
      btn.dataset.title = product.title || 'Gift';
      btn.dataset.price = String(giftWorth(product));
      var src = giftImage(product);
      var img = src
        ? '<img src="' + escapeHtml(src) + '" alt="" width="176" height="176" loading="lazy">'
        : '';
      var worth = formatWorth(giftWorth(product));
      btn.innerHTML =
        '<span class="gf-sd-gift__radio" aria-hidden="true"></span>' +
        '<span class="gf-sd-gift__media">' +
        img +
        '</span><span class="gf-sd-gift__name">' +
        escapeHtml(product.title || 'Gift') +
        '</span>' +
        (worth ? '<span class="gf-sd-gift__worth">Worth ' + escapeHtml(worth) + '</span>' : '') +
        '<span class="gf-sd-gift__free">FREE</span>';
      track.appendChild(btn);
      if (autoSelect) {
        selectedGift = giftFromButton(btn);
        updateGiftChip(selectedGift);
      }
    });
  }

  function matchGiftsInOrder(ids, catalog) {
    var byId = {};
    (catalog || []).forEach(function (product) {
      byId[String(product.id)] = product;
    });
    var matches = [];
    ids.forEach(function (id) {
      if (byId[id]) matches.push(byId[id]);
    });
    return matches;
  }

  function loadGifts(sheet) {
    var dataEl = qs('[data-gf-sd-gift-data]', sheet || document);
    var track = qs('[data-gf-sd-gifts]', sheet || document);
    if (!dataEl || !track || track.dataset.loaded === 'true' || track.dataset.loaded === 'pending') return;
    var payload = {};
    try {
      payload = JSON.parse(dataEl.textContent || '{}') || {};
    } catch (err) {
      payload = {};
    }
    var ids = (payload.ids || []).map(numericId).filter(Boolean);
    if (!ids.length) {
      hideEmptyGiftOffer();
      return;
    }
    track.dataset.loaded = 'pending';
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(root + 'products.json?limit=250')
      .then(function (res) {
        return res.ok ? res.json() : { products: [] };
      })
      .then(function (data) {
        var matches = matchGiftsInOrder(ids, data.products || []);
        track.dataset.loaded = 'true';
        if (!matches.length) {
          renderGifts(track, []);
          return;
        }
        renderGifts(track, matches);
      })
      .catch(function () {
        track.dataset.loaded = '';
      });
  }

  function currentHostVariantId() {
    var input = qs('product-form [name="id"]') || qs('product-info [name="id"]');
    return input ? String(input.value || '') : '';
  }

  function cartAddUrl(value) {
    return /\/cart\/add/i.test(String(value || ''));
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function addSelectedGift(sectionFields) {
    if (!selectedGift || !selectedGift.variantId || giftAddInFlight) return Promise.resolve(null);
    giftAddInFlight = true;
    var body = new FormData();
    body.append('id', selectedGift.variantId);
    body.append('quantity', '1');
    body.append('properties[_gufumart_free_gift]', 'true');
    body.append('properties[_gufumart_gift_price]', '0.00');
    if (sectionFields && sectionFields.sections) {
      body.append('sections', sectionFields.sections);
      body.append('sections_url', sectionFields.sectionsUrl || window.location.pathname);
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body,
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        giftAddInFlight = false;
        return result && result.data ? result.data : null;
      })
      .catch(function () {
        giftAddInFlight = false;
        return null;
      });
  }

  function wrapCartFetch() {
    if (window.__gfSdFetchWrapped || typeof window.fetch !== 'function') return;
    window.__gfSdFetchWrapped = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = requestUrl(input);
      var opts = init || {};
      if (giftAddInFlight || !cartAddUrl(url) || !selectedGift || !selectedGift.variantId) {
        return orig.apply(this, arguments);
      }
      var body = opts.body;
      if (!(body instanceof FormData)) {
        return orig.apply(this, arguments);
      }
      var addedId = String(body.get('id') || '');
      if (!addedId || addedId === String(selectedGift.variantId)) {
        return orig.apply(this, arguments);
      }
      if (addedId !== currentHostVariantId()) {
        return orig.apply(this, arguments);
      }
      var sectionFields = {
        sections: body.get('sections'),
        sectionsUrl: body.get('sections_url'),
      };
      return orig.apply(this, arguments).then(function (res) {
        var clone = res.clone();
        return clone.json().then(function (data) {
          if (!data || data.status) return res;
          return addSelectedGift(sectionFields).then(function (giftData) {
            if (giftData && !giftData.status && giftData.sections) {
              return new Response(JSON.stringify(giftData), {
                status: 200,
                headers: { 'Content-Type': 'application/json' },
              });
            }
            return res;
          });
        }, function () {
          return res;
        });
      });
    };
  }

  function setTab(name) {
    qsa('[data-gf-sd-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-gf-sd-tab') === name;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    qsa('[data-gf-sd-panel]').forEach(function (panel) {
      var show = name === 'all' || panel.getAttribute('data-gf-sd-panel') === name;
      panel.classList.toggle('is-hidden', !show);
    });
  }

  function copyCode(btn) {
    var codeEl = qs('[data-gf-sd-code]');
    if (!codeEl) return;
    var code = codeEl.textContent.trim();
    if (!code) return;
    var done = function () {
      var prev = btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(function () {
        btn.textContent = prev;
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
      return;
    }
    done();
  }

  function onClick(e) {
    if (e.target.closest('[data-gf-sd-open]')) {
      e.preventDefault();
      openSheet();
      return;
    }
    if (e.target.closest('[data-gf-sd-close]') || e.target.closest('[data-gf-sd-scrim]')) {
      e.preventDefault();
      closeSheet();
      return;
    }
    var tab = e.target.closest('[data-gf-sd-tab]');
    if (tab) {
      setTab(tab.getAttribute('data-gf-sd-tab'));
      return;
    }
    var gift = e.target.closest('.gf-sd-gift');
    if (gift) {
      applyGiftSelection(gift);
      return;
    }
    if (e.target.closest('[data-gf-sd-copy]')) {
      e.preventDefault();
      copyCode(e.target.closest('[data-gf-sd-copy]'));
      return;
    }
    var how = e.target.closest('[data-gf-sd-how]');
    if (how) {
      var open = how.getAttribute('aria-expanded') === 'true';
      how.setAttribute('aria-expanded', open ? 'false' : 'true');
      var body = how.nextElementSibling;
      if (body) body.hidden = open;
    }
  }

  function boot() {
    if (!qs(ROOT)) return;
    wrapCartFetch();
    loadGifts(qs('.gf-sd-sheet'));
    document.addEventListener('click', onClick);
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (type) {
      document.addEventListener(type, blockUnderlying, { capture: true, passive: false });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        closeSheet();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
